import { render, staticRenderFns } from "./RsaConfigurazioneParametriVitaliPresidioListPage.vue?vue&type=template&id=2b96d19a"
import script from "./RsaConfigurazioneParametriVitaliPresidioListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneParametriVitaliPresidioListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports